import { render, staticRenderFns } from "./CustomizeColumnMenu.vue?vue&type=template&id=66e6c48d&scoped=true"
import script from "./CustomizeColumnMenu.vue?vue&type=script&lang=js"
export * from "./CustomizeColumnMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomizeColumnMenu.vue?vue&type=style&index=0&id=66e6c48d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6c48d",
  null
  
)

export default component.exports